export default theme => ({
  root: {},
  overlay: {
    zIndex: 1601
  },
  content: {
    position: 'relative',
    marginTop: '12px',
    marginBottom: '8px'
  },
  inputOne: {
    marginBottom: '12px'
  },
  inputTwo: {
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  checkboxContainer: {
    width: '100%',
    marginTop: '24px',
    display: 'flex'
  },
  checkboxText: {
    marginLeft: '8px'
  },
  formContainer: {
    opacity: 1,
    transition: 'all .15s ease'
  },
  formContainerHidden: {
    opacity: 0
  },
  loaderContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
});